module.exports = __webpack_public_path__ + "img/news-3.655c20fb.png";